export const APP_THEME_PREFERENCES = ["light", "dark", "system"] as const;

export type AppThemePreference = (typeof APP_THEME_PREFERENCES)[number];

export type ResolvedColorScheme = "light" | "dark";

export function isAppThemePreference(
    value: string,
): value is AppThemePreference {
    return (APP_THEME_PREFERENCES as readonly string[]).includes(value);
}

export function resolveColorScheme(
    preference: AppThemePreference,
    systemScheme: ResolvedColorScheme,
): ResolvedColorScheme {
    return preference === "system" ? systemScheme : preference;
}
